<!-- content block start  -->
<div class="content-wrap">

    <div class="content-block">
        <router-outlet></router-outlet>
    </div>
</div>
<!-- content block end  -->